import React from 'react'
import { Box, Grid, SxProps, Theme, useMediaQuery } from '@mui/material'

type Props = {
  right: React.ReactNode
  left: React.ReactNode
}
const SignupTemplate: React.FC<Props> = (props: Props) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  const classContainer: SxProps = {
    minHeight: '100vh',
    alignItems: 'stretch',
    // alignItems: 'center',
  }
  const gridChildContainer: SxProps = {
    bgcolor: '#FAF8F7',
    p: { xs: '40px', lg: '60px' },
    // minHeight: '100vh',
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center',
    // boxSizing: 'border-box',
  }
  const gridRight: SxProps = {
    // height: '100vh',
    // alignItems: 'center',
    // alignSelf: 'start',
    // display: 'flex',
  }

  const gridRightChild: SxProps = {
    width: '598px',
    maxWidth: '50vw',
    paddingTop: 10,
  }
  if (isMobile) {
    return <Box sx={gridRight}>{props.right}</Box>
  }
  return (
    <Grid container sx={classContainer}>
      <Grid item xs sx={gridChildContainer}>
        <Box maxWidth={{ lg: '515px', md: 'fit-content', xl: 'fit-content' }} mx="auto">
          {props.left}
        </Box>
      </Grid>

      <Grid item xs="auto" sx={gridRight}>
        <Box sx={gridRightChild}>{props.right}</Box>
      </Grid>
    </Grid>
  )
}

export default SignupTemplate
